import { Person, Settings } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import ChipTabs from "../../../../components/ChipsTabs";
import ErrorFullScreenMessage from "../../../../components/fullScreenMessage/ErrorFullScreenMessage";
import Skeletons from "../../../../components/loader/Skeletons";
import { EDITING_USER_DETAILS } from "../../../../enums/QueryKeys";
import { useFetch } from "../../../../hooks/Fetching";
import EditingInformationForm from "../../../profile/form/EditingInformationForm";
import UserPreferences from "./UserPreferences";
import dayjs from "dayjs";

export default function SingleUserEditing({ setViewEditForm }) {
  const { id } = useParams();

  const { data, isLoading, error } = useFetch(
    "/users/details/" + id,
    null,
    EDITING_USER_DETAILS + id
  );

  if (isLoading) {
    return <Skeletons numOfSkeletons={5} grid={false} height={50} />;
  } else if (error) {
    return <ErrorFullScreenMessage />;
  }

  const profile = {
    id: id,
    birthday: data?.userDetails?.birthday ? dayjs(data?.userDetails?.birthday, "DD/MM/YYYY", true) : null,
    email: data?.userDetails?.email ?? null,
    firstName: data?.userDetails?.firstName ?? null,
    lastName: data?.userDetails?.lastName ?? null,
    username: data?.userDetails?.username ?? null,
    role: data?.role ?? null,
    phoneNumber: data?.userDetails?.phoneNumber ?? null,
    oib: data?.userDetails?.oib ?? null,
    idCardNumber: data?.userDetails?.idCardNumber ?? null,
    initials: String(data?.userDetails?.lastName).charAt(0).toUpperCase() +
        String(data?.userDetails?.firstName).charAt(0).toUpperCase(),
    location: data?.userDetails?.location ?? null,
  };

  const preferance = {
    defaultLanguage: data?.userPreferences?.language ?? "hr",
    defaultTheme: data?.userPreferences?.theme ?? "dark",
    defaultCalendarView: data?.userPreferences?.calendarView ?? null,
    defaultEmailSending: data?.userDetails?.subscribeToEmails ?? true,
    isActive: data?.active ?? false,
    clinic: data?.clinic,
    appointmentTableRowsPerPage: data?.userPreferences?.appointmentTableRowsPerPage ?? 10,
    clinicUsersTableRowsPerPage: data?.userPreferences?.clinicUsersTableRowsPerPage ?? 10,
    sendAppointmentEmailsWhenUpdated: data?.userPreferences?.sendAppointmentEmailsWhenUpdated ?? true,
    sendAppointmentEmails: data?.userPreferences?.sendAppointmentEmails ?? true,
    sendInboxEmails: data?.userPreferences?.sendInboxEmails ?? true,
    disableAllEmails: data?.userPreferences?.disableAllEmails ?? false
  };

  const content = [
    <EditingInformationForm
      profile={profile}
      setViewEditForm={setViewEditForm}
      allowEmailEdit={!data?.active}
    />,
    <UserPreferences preferance={preferance} />,
  ];
  const title = ["UserProfile", "UserPreferences"];
  const icons = [<Person />, <Settings />];

  return (
    <ChipTabs
      lsKey={"SINGLE_USER_EDITING_LS_KEY"}
      icons={icons}
      tabContent={content}
      tabLabels={title}
    />
  );
}
